// extracted by mini-css-extract-plugin
module.exports = {"link":"_3phcs","image":"ptcvm","ScotchTapePhoto":"FCYB0","scotchTapePhoto":"FCYB0","wrp":"_3wxtV","xxx":"_22JwU","left":"_1fCnu","right":"zzJhc"};